import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesLeft } from '@fortawesome/free-solid-svg-icons';

interface Props {
    path?: string | null;
    state?: any;
}

export const GoBackBtn: FC<Props> = ({ path, state }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const onHandleClick = (): void => {
        switch (true) {
            case !!path && !!state:
                navigate(path, { state });
                break;
            case !!path:
                navigate(path);
                break;
            default: navigate(-1);
        }
    };

    return (
        <ButtonComponent
            buttonType={BUTTON_TYPE.TRANSPARENT}
            onButtonClick={onHandleClick}
        >
            <div className="d-flex align-items-center">
                <FontAwesomeIcon icon={faAnglesLeft}/>
                <span className="ms-2">{t('GENERAL.RETURN_BTN_NAME')}</span>
            </div>
        </ButtonComponent>
    );
};
